/* ----------------------------

Initialize all plugins used with custom options.

---------------------------- */

jQuery(document).ready(function(){


	// Init Homepage Hero Rotator with custom Cycle2 options
	//------------------------------------------------------

	jQuery('#homepage-hero-rotator').cycle({
		autoHeight: false,
		speed: 500,
		fx: 'fade',
		slides: '> div.slide',
		pauseOnHover: true,
		swipe: true,
		timeout: 6000
	});


	// Init Mobile Nav
	//------------------------------------------------------

	var sidrSource = '#search-wrap,';
	if ( jQuery( '.header-brand' ).hasClass( 'd-flex' ) ) {
		sidrSource = sidrSource + ' #nav';
	} else {
		sidrSource = sidrSource + ' #nav-left, #nav-right';
	}

	// init plugins with custom options
	jQuery('#mobile-nav-toggle').sidr({
		name: 'mobile-nav',
		source: sidrSource,
		renaming: false,
		side: 'right',
		speed: 300, // this speed should match the $header-transition-time variable in the _header.scss partial
		timing: 'linear', // this speed should match the $header-transition-easing variable in the _header.scss partial
		onOpen: function() {
			jQuery('body').addClass('mobile-nav-opening');},
		onOpenEnd: function() {
			jQuery('body').removeClass('mobile-nav-opening');},
		onClose: function() {
			jQuery('body').addClass('mobile-nav-closing').removeClass('mobile-nav-open');},
		onCloseEnd: function() {
			jQuery('body').removeClass('mobile-nav-closing');}
	});

	// attach swipe events to open/close menu (but only below the mobile nav breakpoint width and only on touch devices)
	if (jQuery(window).width() <= 959) {
		jQuery('html.touch body').swipe( {
			//open menu on swipe left
			swipeLeft: function () {
				jQuery.sidr('open', 'mobile-nav');
			},
			//open menu on swipe right
			swipeRight: function () {
				jQuery.sidr('close', 'mobile-nav');
			},
			threshold: 75
		});
	}

	// Open Video in colorbox popup.
	jQuery( '.cboxElement' ).colorbox({
			iframe: true,
			innerWidth: 640,
			innerHeight: 409,
			maxWidth: '95%',
			maxHeight: '95%'
	});

	// close mobile nav when close button is clicked
	jQuery('#mobile-nav-close').click(function(e) {
		e.preventDefault();
		jQuery.sidr('close', 'mobile-nav');
	});



	jQuery(window).resize(function(){

    // close the mobile menu and restore default position of body/header on large screens
    if (jQuery(window).width() > 959) { // update width if there is a change to the $grid-float-breakpoint variable
      if (jQuery('body').hasClass('sidr-open')) {
        jQuery.sidr('close', 'mobile-nav');
      }
    }
	});


	$('.product-carousel').slick({
		infinite: true,
		slidesToShow: 3,
		slidesToScroll: 1,
		responsive: [
			{
			  breakpoint: 960,
			  settings: {
				slidesToShow: 2,
				slidesToScroll: 1
			  }
			},
			{
			  breakpoint: 768,
			  settings: {
				slidesToShow: 1,
				slidesToScroll: 1
			  }
			}
		]
	  });



});
